import React from 'react';
import classNames from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ELearningPerformance = ({ eLearningScores, canViewTimeSpent }) => {
  const RenderScores = () => {
    return eLearningScores.map(performance => (
      <tr key={performance.content}>
        <td className="DataTable-name wide">{performance.content}</td>
        <td>{performance.status}</td>
        <td
          className={classNames({
            'data--blank': performance.state === 'Unknown',
          })}
        >
          {performance.state !== 'Unknown' ? performance.state : 'N/A'}
        </td>
        <td
          className={classNames({
            'data--blank': !performance.score,
          })}
        >
          {performance.score ? `${performance.score * 100}%` : 'N/A'}
        </td>
        {canViewTimeSpent && <td>{performance.totalSecondsTracked}</td>}
      </tr>
    ));
  };

  return (
    <>
      <h4>{t('progress.report_card.elearning.title')}</h4>
      <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
        {t('progress.report_card.elearning.description')}
      </Text>
      <table className="DataTable Table ReportCard-ELearning">
        <thead>
          <tr>
            <th className="DataTable-name wide">Content</th>
            <th>Completion</th>
            <th>Success</th>
            <th>Score</th>
            {canViewTimeSpent && <th>Time Spent</th>}
          </tr>
        </thead>
        <tbody>
          <RenderScores />
        </tbody>
      </table>
    </>
  );
};

export default ELearningPerformance;
